import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import './App.css'

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Categories from './pages/Categories';
import Winners from './pages/Winners';
// import Blog from './pages/Blog';
// import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import VerifyEmail from './pages/auth/VerifyEmail';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
// import Nominate from './pages/nominations/Nominate';
import NominationGuide from './pages/nominations/NominationGuide';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import IntellectualProperty from './pages/IntellectualProperty';
// import NominationCategories2 from './pages/nominations/NominationCategories2';
// import NominationForm from './pages/nominations/NominationForm';
// import MyNominations from './pages/nominations/MyNominations';
// import NominationDetails from './pages/nominations/NominationDetails';
// import Vote from './pages/voting/Vote';
// import VotingCategories from './pages/voting/VotingCategories';
// import VotingNominees from './pages/voting/VotingNominees';
// import MyVotes from './pages/voting/MyVotes';
import BlogList from './pages/admin/BlogList';
import BlogEditorPage from './pages/admin/BlogEditor';

// Layout
import Layout from './components/layout/Layout';

// Context
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="categories" element={<Categories />} />
            <Route path="winners" element={<Winners />} />
            <Route path="winners/:year" element={<Winners />} />
            {/* <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} /> */}
            <Route path="contact" element={<Contact />} />
            
            {/* Authentication Routes */}
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            
            {/* Nomination Routes */}
            <Route path="nominate" element={<NominationGuide />} />
            {/* <Route path="nominate-form" element={<Nominate />} /> */}
            
            {/* Policy Pages */}
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="intellectual" element={<IntellectualProperty />} />
            {/* Placing these temporary for testing purposes */}
            {/* <Route path="nomination-categories" element={<NominationCategories2 />} />
            <Route path="nomination-form/:categoryId" element={<NominationForm />} />
            <Route path="my-nominations" element={<MyNominations />} />
            <Route path="nomination/:id" element={<NominationDetails />} />
            {/* Protected Nomination Routes */}
            {/* <Route path="nomination-categories" element={
              <ProtectedRoute>
                <NominationCategories />
              </ProtectedRoute>
            } />
            <Route path="nomination-form/:categoryId" element={
              <ProtectedRoute>
                <NominationForm />
              </ProtectedRoute>
            } />
            <Route path="my-nominations" element={
              <ProtectedRoute>
                <MyNominations />
              </ProtectedRoute>
            } />
            <Route path="nomination/:id" element={
              <ProtectedRoute>
                <NominationDetails />
              </ProtectedRoute>
            } /> */}
            
            {/* Voting Routes */}
            {/* <Route path="vote" element={<Vote />} /> */}
            
            {/* Protected Voting Routes */}
            {/* <Route path="voting-categories" element={
              <ProtectedRoute>
                <VotingCategories />
              </ProtectedRoute>
            } />
            <Route path="voting-nominees/:categoryId" element={
              <ProtectedRoute>
                <VotingNominees />
              </ProtectedRoute>
            } />
            <Route path="my-votes" element={
              <ProtectedRoute>
                <MyVotes />
              </ProtectedRoute>
            } /> */}
            
            {/* Admin Blog Routes */}
            <Route path="admin/blog" element={
              <ProtectedRoute>
                <BlogList />
              </ProtectedRoute>
            } />
            <Route path="admin/blog/create" element={
              <ProtectedRoute>
                <BlogEditorPage />
              </ProtectedRoute>
            } />
            <Route path="admin/blog/edit/:id" element={
              <ProtectedRoute>
                <BlogEditorPage />
              </ProtectedRoute>
            } />
            
            {/* 404 Redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;